import * as React from 'react';
import { joinClassNames } from '@/lib/class-names';
import s from './ContentState.module.scss';

type ContentStateSize = 'md' | 'lg';

export interface ContentStateProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'title'
> {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  minHeight?: number | string;
  size?: ContentStateSize;
}

export function ContentState({
  icon,
  title,
  description,
  action,
  minHeight,
  size = 'md',
  className,
  style,
  ...rest
}: ContentStateProps) {
  return (
    <div
      className={joinClassNames(s.root, className)}
      style={{ ...style, minHeight }}
      {...rest}
    >
      {icon ? <div className={s.icon}>{icon}</div> : null}
      {title ? (
        <p
          className={joinClassNames(
            s.title,
            size === 'lg' ? s.titleLg : s.titleMd,
          )}
        >
          {title}
        </p>
      ) : null}
      {typeof description === 'string' ? (
        <p className={s.description}>{description}</p>
      ) : (
        description
      )}
      {action ? <div className={s.action}>{action}</div> : null}
    </div>
  );
}
